// extracted by mini-css-extract-plugin
module.exports = {"active":"styles_active__XPauE","timerWrapper":"styles_timerWrapper__uHScw"};